import { render } from "./componentTypeList.vue?vue&type=template&id=3c8353aa"
import script from "./componentTypeList.vue?vue&type=script&lang=js"
export * from "./componentTypeList.vue?vue&type=script&lang=js"

import "./componentTypeList.vue?vue&type=style&index=0&id=3c8353aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__